<template>
    <div>
        <v-container class="main-header py-0 px-sm-2 px-0" :class="{'isCheckout': isCheckout}">
            <v-layout align-center>
                <router-link to="/" class="main-link">
                    <img :src="require('../../assets/zoo.svg')" class="custom-logo" :class="{'isCheckout': isCheckout}" itemprop="logo" v-if="$vuetify.breakpoint.smAndUp && !isCheckout" />
                    <img v-else :src="require('../../assets/logo_sirka.png')" class="mobile-custom-logo" />
                </router-link>
                <div class="main-title" :class="{'mobile-main-title': $vuetify.breakpoint.xsOnly}" >
                    Klub přátel
                    <strong>Zoo Liberec</strong>
                </div>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

    export default {
        name: 'MainHeader',
        props: ['isCheckout'],
        data () {
            return {
                drawer: false,
                menu: false
            }
        },

        computed: {

        }
    }
</script>

<style lang="scss">
    .main-header {
        .main-link {
            line-height: 0;
        }
        .main-cart {
            display: inline-flex;
            cursor: pointer;
        }
        .cart-title {
            display: inline-flex;
            margin-top: 5px;
            color: #FFFFFF;
        }
        .cart-image {
            cursor: pointer;
            width: 40px;
        }
        .mobileCart {
            max-width: 80px;
        }
        background-color: #53332c !important;
        &.isCheckout {
            padding-top: 0;
            padding-bottom: 0;
        }
        .menu-item {
            a {
                padding: 0 1em;
                font-size: 16px;
                color: #FFFFFF !important;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
        .main-title {
            color: #FFFFFF;
            font-weight: 300;
            text-transform: uppercase;
            margin-left: 40px;
            strong {
                display: block;
                font-weight: 700;
                font-size: 32px;
                line-height: 32px;
            }
          &.mobile-main-title {
            margin-left: 20px;
            font-size: 16px;
            strong {
              font-size: 16px;
            }
          }
        }
        .mobile-custom-logo {
            max-width: 140px;
        }
        .custom-logo {
            max-width: 180px;
            &.isCheckout {
                max-width: 150px;
            }
        }
        .menu-icon-link {
            border-radius: 7px !important;
        }
        .v-list, .v-menu__content {
            border-radius: 0 !important;
        }
        .v-menu__content {
            max-width: 100% !important;
            width: 100%;
            left: 0 !important;
        }
        .v-chip {
            .v-chip__content {
                cursor: pointer !important;
            }
        }
        .opening-hours {
            strong {
                display: block;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }
</style>
